var _g, _rect, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRow64(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1322_39096)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 60,
    rx: 8,
    fill: "#161616"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 60,
    fill: "#161616"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_1322_39096)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4 18.001V43.001H56V37.6315H55.9736C55.7599 38.2245 55.3205 37.595 55.0512 37.4679C54.8172 37.3575 54.5367 37.4341 54.3132 37.5497C53.9284 37.7487 53.5987 38.05 53.259 38.3291C53.1333 38.4323 52.8974 38.5748 52.8241 38.7285C52.7511 38.8817 52.8109 39.2199 52.8109 39.3924V41.0091H54.1814C54.397 41.0091 54.6606 40.9691 54.8667 41.0476C55.2299 41.1857 55.1031 41.6944 54.7613 41.7308C53.9271 41.8196 53.0434 41.7308 52.2048 41.7308C51.8471 41.7308 51.3334 41.8353 50.9924 41.7212C50.6951 41.6217 50.6445 41.2201 50.9397 41.0764C51.2494 40.9257 51.7889 41.0379 52.1257 41.0379V37.5449H51.5722C51.2834 37.5449 50.6822 37.2414 51.1242 36.8905C51.4062 36.6666 52.0532 36.7943 52.3893 36.7943C52.4849 36.7943 52.7084 36.7493 52.7801 36.828C52.8328 36.8857 52.8109 37.0084 52.8109 37.083V37.7758C53.0534 37.6709 53.2827 37.4059 53.4962 37.2369C54.1111 36.7506 54.9012 36.4827 55.5783 36.9771C55.733 37.0901 55.8893 37.2159 55.9736 37.4005H56V18.001H50.7288H49.3583C49.2413 18.001 48.9353 17.9403 48.8399 18.0154C48.7735 18.0678 48.754 18.2118 48.7213 18.2897C48.6025 18.574 48.5226 18.8813 48.4535 19.1846C48.3515 19.6314 48.2195 20.2448 48.4095 20.6857C48.5453 21.0006 48.9836 21.26 49.2002 21.5229C49.7571 22.1987 50.1227 23.0618 50.1227 23.9767C50.1227 24.6317 49.9303 25.2776 49.6042 25.8243C49.4846 26.0252 49.3517 26.2284 49.2002 26.4017C49.1449 26.4649 49.0017 26.5677 48.9981 26.6615C48.992 26.8222 49.2732 27.153 49.3496 27.2966C49.589 27.7461 49.7745 28.2621 49.9031 28.7689C50.3852 30.6698 50.3533 32.8496 49.5737 34.658C49.3884 35.0877 49.1854 35.4886 48.919 35.8705C48.8323 35.9948 48.7234 36.1842 48.5985 36.265C48.5326 36.3076 48.3916 36.1974 48.3305 36.164C48.1499 36.0652 47.8924 35.7924 47.6979 35.7599C47.6004 35.7435 47.5042 35.8756 47.4344 35.9331C47.2372 36.0951 47.0309 36.2382 46.8282 36.3901L46.8809 36.65C47.3848 36.6935 47.8729 36.8851 48.2777 37.2177C48.5529 37.4437 48.7948 37.7112 48.9717 38.0356C49.7387 39.4422 48.9941 41.1377 47.6716 41.7212C46.4118 42.277 44.7318 41.6486 44.2103 40.2296C44.0513 39.7973 44.0142 39.3896 44.0608 38.9306C44.1096 38.4508 44.3186 37.9902 44.6143 37.6315C44.7195 37.504 44.8765 37.3962 44.9569 37.2562L43.6128 37.4871L42.1632 37.4294C42.1632 37.7185 42.1785 38.7975 41.6361 38.4013C41.4229 38.2455 41.5138 37.9529 41.3375 37.7806C41.2444 37.69 41.1572 37.8624 41.0563 37.8624C40.8723 37.8624 40.8185 37.6115 40.7927 37.4583C40.6464 37.4625 40.5753 37.6499 40.4237 37.6315C40.2229 37.607 40.2608 37.3717 40.0284 37.3717C39.6499 37.3717 39.2301 37.4407 38.9214 37.6988C38.64 37.9344 38.7043 38.2925 39.0005 38.4638C40.0244 39.0558 41.5971 38.4098 42.2686 39.7677C42.626 40.4902 42.1553 41.2545 41.557 41.5913C40.6085 42.1252 39.3956 41.976 38.4734 41.471C38.379 41.7328 38.0443 41.8408 37.8759 41.5864C37.7038 41.3262 37.752 40.6479 37.8058 40.3451C37.829 40.2136 37.8369 40.0952 37.9463 40.0083C38.1139 39.8752 38.3545 39.9472 38.4515 40.143C38.5469 40.3361 38.4855 40.5419 38.636 40.7204C39.0606 41.2243 39.9836 41.2732 40.5555 41.1775C41.0051 41.1022 42.0098 40.7293 41.6361 40.0275C41.44 39.6594 40.9274 39.5719 40.5819 39.4983C39.7263 39.3161 38.4855 39.4659 38.0868 38.3821C37.7291 37.4092 38.8924 36.7002 39.633 36.6788L39.6286 36.4816L39.3168 36.265L38.6579 35.7262H38.6315C38.364 35.9651 38.0293 36.1743 37.7091 36.3035C37.6498 36.079 37.3733 35.8366 37.2434 35.6396C36.9658 35.2183 36.755 34.7342 36.5845 34.2539C35.9514 32.4702 35.9382 30.3444 36.488 28.5379C36.6804 27.9051 36.9208 27.189 37.3401 26.6904V26.6615C36.1612 25.3353 35.8317 23.5682 36.7953 21.9848C37.0022 21.645 37.2745 21.3344 37.5509 21.061C37.7146 20.8991 37.9091 20.7953 37.9639 20.5414C38.1334 19.7542 37.8169 18.7281 37.4982 18.0299C37.8155 18.103 38.1284 18.3646 38.4207 18.5158C39.0482 18.8403 39.7113 19.1627 40.3974 19.3193C40.8204 19.4158 41.2692 19.2307 41.6888 19.1605C42.1426 19.0846 42.6031 19.0888 43.0593 19.0403C43.6626 18.976 44.3357 19.123 44.9306 19.2135C45.1651 19.2491 45.4313 19.3831 45.6685 19.3578C46.8197 19.2352 47.7617 18.4508 48.8049 18.0299C48.6567 17.9119 48.1821 18.001 47.9878 18.001H45.7212H37.0765H4Z",
    fill: "#161616"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.5508 18.0586C37.5645 18.2495 37.6858 18.4518 37.744 18.636C37.9248 19.2061 38.1523 20.0043 37.9638 20.599C37.8932 20.8218 37.6845 20.9583 37.5245 21.0994C37.3231 21.2771 37.1397 21.5036 36.9797 21.7249C36.1661 22.8507 35.9903 24.3145 36.6065 25.5932C37.1091 26.6365 38.0508 27.3874 39.0004 27.8787C41.276 29.0556 44.2017 29.2363 46.5645 28.2299C47.8512 27.6818 49.1827 26.8561 49.8018 25.42C50.3463 24.1572 50.098 22.7682 49.3232 21.696C49.1376 21.4395 48.9199 21.2214 48.6993 21.0032C48.5863 20.8914 48.4461 20.8168 48.3831 20.6567C48.0462 19.8001 48.6226 18.8692 48.7784 18.0586C47.8122 18.4485 46.8945 19.2439 45.8266 19.3577C45.4818 19.3944 45.1613 19.2543 44.825 19.2133C44.202 19.1375 43.5333 19.0017 42.9011 19.069C42.4348 19.1186 41.9697 19.1567 41.5042 19.2133C41.1566 19.2556 40.8053 19.4237 40.45 19.348C39.3936 19.1231 38.531 18.4541 37.5508 18.0586Z",
    fill: "#7B7D7F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.9805 19.0391V19.0679H43.0859L42.9805 19.0391Z",
    fill: "#FFF8DD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.0859 19.0391V19.0679H43.2177L43.0859 19.0391Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.2168 19.0391V19.0679H43.3222L43.2168 19.0391Z",
    fill: "#FFF8DD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.6904 19.0684V19.0972H42.7695L42.6904 19.0684Z",
    fill: "#99999B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.7695 19.0684V19.0972H42.8486L42.7695 19.0684ZM43.4811 19.0684V19.0972H43.5602L43.4811 19.0684Z",
    fill: "#8B8B8C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.5596 19.0684V19.0972H43.6386L43.5596 19.0684Z",
    fill: "#99999B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.999 19.9922V20.0788H38.0254L37.999 19.9922Z",
    fill: "#99999B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.3047 20.0215V20.1081H48.331L48.3047 20.0215Z",
    fill: "#B4B5B6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.998 20.0781V20.2513H38.0244L37.998 20.0781Z",
    fill: "#A9ABAF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.3047 20.1074V20.194H48.331L48.3047 20.1074Z",
    fill: "#C1C2C3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.3047 20.1934V20.28H48.331L48.3047 20.1934Z",
    fill: "#B4B5B6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.7119 21.1465V21.1754H39.791L39.7119 21.1465Z",
    fill: "#A9ABAF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.79 21.1465V21.1754H39.9218L39.79 21.1465Z",
    fill: "#B4B5B6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.3271 21.1465V21.1754H46.4062L46.3271 21.1465Z",
    fill: "#A9ABAF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.4062 21.1465V21.1754H46.538L46.4062 21.1465Z",
    fill: "#B4B5B6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.5381 21.1465V21.1754H46.6172L46.5381 21.1465Z",
    fill: "#A9ABAF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.5805 21.1863C38.6644 21.3815 37.8684 21.852 37.4501 22.8222C36.5548 24.8986 38.2268 27.3862 40.3184 26.9407C41.5334 26.682 42.6325 25.4012 42.506 23.9769C42.3705 22.4498 41.1281 20.8567 39.5805 21.1863Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.2221 21.1848C45.2859 21.3842 44.4934 21.8565 44.0654 22.8495C43.1785 24.9063 44.8735 27.378 46.9337 26.9392C48.0992 26.691 49.005 25.661 49.1212 24.3507C49.2694 22.6825 47.8456 20.839 46.2221 21.1848Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.791 22.418V22.4468H39.8964L39.791 22.418Z",
    fill: "#595757"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.4316 22.418V22.4468H46.5107L46.4316 22.418Z",
    fill: "#484646"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.4745 22.475V22.5039C40.3381 22.7031 39.8403 24.204 39.0264 23.8078C38.9144 23.7532 38.824 23.6534 38.7542 23.5432C38.6659 23.4039 38.6574 23.274 38.6574 23.1101C38.3546 23.3187 38.3238 23.9777 38.3675 24.3226C38.4803 25.2119 39.2847 25.8738 40.107 25.6987C41.2725 25.4504 41.7838 23.8162 40.8932 22.8888C40.4802 22.4586 40.009 22.4288 39.4745 22.475Z",
    fill: "#373535"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.1177 22.4747V22.5035C46.9669 22.6994 46.4582 24.2393 45.6696 23.8074C45.5479 23.7408 45.4625 23.6665 45.3842 23.5428C45.3057 23.4189 45.2743 23.2595 45.2743 23.1098C45.0408 23.3262 44.9844 23.7738 44.9844 24.0913C44.9844 25.2322 46.0697 26.0399 47.0401 25.6117C48.0843 25.151 48.3179 23.5335 47.4091 22.773C47.0396 22.4638 46.5681 22.3838 46.1177 22.4747Z",
    fill: "#373535"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.207 23.7734V23.86H36.2334L36.207 23.7734Z",
    fill: "#99999B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.0967 23.8027V23.9182H50.123L50.0967 23.8027Z",
    fill: "#A9ABAF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.207 23.8613V24.0634H36.2334L36.207 23.8613Z",
    fill: "#8B8B8C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.8809 23.8613V23.8902H45.9599L45.8809 23.8613Z",
    fill: "#595757"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.0957 23.918V24.0046H50.1221L50.0957 23.918Z",
    fill: "#99999B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.1826 23.9473V24.0339H37.209L37.1826 23.9473Z",
    fill: "#DEDDDE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.7969 23.9473V24.2071H43.8232L43.7969 23.9473Z",
    fill: "#99999B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.957 23.9766V24.0632H44.9834L44.957 23.9766Z",
    fill: "#706E6F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.1211 23.9766V24.1786H49.1474L49.1211 23.9766Z",
    fill: "#CFCCC5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.3457 24.0059V24.1502H41.3721L41.3457 24.0059Z",
    fill: "#99999B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.5059 24.0059V24.1502H42.5322L42.5059 24.0059Z",
    fill: "#8B8B8C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.9883 24.0059V24.1502H48.0146L47.9883 24.0059Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.0957 24.0059V24.1213H50.1221L50.0957 24.0059Z",
    fill: "#A9ABAF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.1816 24.0332V24.1198H37.208L37.1816 24.0332Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.3145 24.0332V24.1198H38.3408L38.3145 24.0332Z",
    fill: "#D3D3D5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.207 24.0625V24.1491H36.2334L36.207 24.0625Z",
    fill: "#99999B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.957 24.0918V24.1784H44.9834L44.957 24.0918Z",
    fill: "#706E6F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.1816 24.1211V24.2077H37.208L37.1816 24.1211Z",
    fill: "#DEDDDE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.3809 25.709V25.7379H46.4599L46.3809 25.709Z",
    fill: "#484646"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.1621 26.373V26.4019H43.9807L43.4799 26.373H42.1621Z",
    fill: "#C9AC4D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.1895 26.4004C42.2756 26.8483 42.6483 27.3224 42.8439 27.7283C42.9134 27.8726 42.9793 28.0836 43.0856 28.1902C43.3976 27.6493 43.78 27 43.9816 26.4004H42.1895Z",
    fill: "#FFCD29"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.5056 28.739C41.1456 28.6249 40.7621 28.5802 40.3987 28.4696C39.6874 28.2531 38.9955 27.936 38.3693 27.5169C38.1002 27.3368 37.8498 27.1267 37.605 26.9107C37.5457 26.8584 37.4279 26.6674 37.3414 26.7038C37.2125 26.7581 37.0834 27.1114 37.0207 27.2379C36.7429 27.7999 36.5265 28.3737 36.3839 28.9988C35.9577 30.8654 36.0126 33.026 36.8098 34.7725C36.9848 35.1558 37.1709 35.5241 37.4118 35.8695C37.4885 35.9798 37.61 36.2119 37.7368 36.2544C37.892 36.3064 38.2702 35.99 38.3957 35.8984C39.0195 35.4429 39.5261 34.8785 39.9419 34.1951C40.3228 33.5693 40.6206 32.8886 40.838 32.1744C41.1841 31.0372 41.3101 29.9026 41.5056 28.739Z",
    fill: "#A9ABAF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.9891 26.6895C48.8594 26.7306 48.7477 26.8795 48.6465 26.9781C48.4638 27.156 48.249 27.3195 48.0403 27.4593C47.3833 27.8992 46.6782 28.2425 45.9318 28.4697C45.6633 28.5514 45.3889 28.6182 45.1148 28.6765C45.0423 28.692 44.8578 28.6877 44.8294 28.7728C44.7927 28.8817 44.8673 29.0863 44.8776 29.201C44.9137 29.6082 44.977 30.0114 45.0534 30.4135C45.3768 32.1143 45.9218 33.6675 46.9552 35.0035C47.2792 35.4223 47.689 35.7486 48.1194 36.0235C48.2298 36.0942 48.4335 36.2695 48.5674 36.2593C48.696 36.2495 48.8568 35.9449 48.9319 35.8407C49.2912 35.3439 49.5286 34.7787 49.7358 34.1952C50.3765 32.3908 50.3868 30.0861 49.7447 28.2772C49.5407 27.7029 49.2582 27.2228 48.9891 26.6895Z",
    fill: "#A9ABAF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.7383 26.9785V27.0074H39.9491L39.7383 26.9785Z",
    fill: "#B4B5B6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.3809 26.9785V27.0074H46.5917L46.3809 26.9785Z",
    fill: "#B4B5B6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.4512 28.7109V28.7398H41.5566L41.4512 28.7109Z",
    fill: "#99999B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.7715 28.7109V28.7398H44.8769L44.7715 28.7109Z",
    fill: "#99999B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.5027 28.7383C41.5027 29.2533 41.3965 29.7936 41.3005 30.2972C41.0538 31.5942 40.7028 32.8594 40.0708 33.9923C39.8217 34.4386 39.5199 34.8362 39.1834 35.2048C39.0695 35.3296 38.7517 35.5386 38.6958 35.6956C38.6631 35.7875 38.8394 35.8909 38.8935 35.9361C39.113 36.1198 39.4103 36.4118 39.6841 36.475C39.7152 36.3135 39.935 35.8937 40.1322 35.9987C40.3367 36.1075 40.3167 36.3857 40.3167 36.5905H40.343C40.5357 36.0558 40.9229 36.34 40.9229 36.7926H40.9492C40.9898 36.73 41.0304 36.6733 41.081 36.6193C41.3403 36.3433 41.5517 36.6972 41.529 36.9946C41.5235 37.0677 41.4703 37.1802 41.5159 37.2496C41.621 37.4095 41.9774 37.2776 42.1044 37.4084C42.1958 37.5026 42.1352 37.9003 42.1352 38.0339H42.1616V37.3988L43.7429 37.4565L45.008 37.2256C45.008 37.0209 44.945 36.8217 45.0167 36.6193C45.148 36.2498 45.4534 36.4979 45.5615 36.7348H45.5878C45.5878 36.2952 45.8891 35.9748 46.1413 36.475H46.1677C46.1677 36.3019 46.2061 35.8537 46.4576 35.9072C46.6497 35.9482 46.7367 36.2036 46.8266 36.3595C47.1212 36.2746 47.3987 35.9438 47.6436 35.7533V35.6956C45.5839 34.0926 45.2167 31.2333 44.7972 28.7383C44.1464 28.7945 43.482 28.9531 42.8205 28.8826C42.3882 28.8366 41.9349 28.7508 41.5027 28.7383Z",
    fill: "#D3D3D5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.4775 28.7969V28.8835H41.5039L41.4775 28.7969Z",
    fill: "#B4B5B6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.4795 28.8262V28.855H42.5849L42.4795 28.8262Z",
    fill: "#99999B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.585 28.8262V28.855H42.664L42.585 28.8262ZM43.6655 28.8262V28.855H43.7446L43.6655 28.8262Z",
    fill: "#8B8B8C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.7451 28.8262V28.855H43.8242L43.7451 28.8262Z",
    fill: "#99999B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.8232 28.8262V28.855H43.9023L43.8232 28.8262Z",
    fill: "#A9ABAF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.7949 28.8555V28.8843H42.9531L42.7949 28.8555Z",
    fill: "#C1C2C3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.9551 28.8555V28.8843H43.3768L42.9551 28.8555Z",
    fill: "#B4B5B6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.377 28.8555V28.8843H43.5351L43.377 28.8555Z",
    fill: "#C1C2C3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.8242 28.9414V29.028H44.8506L44.8242 28.9414Z",
    fill: "#C1C2C3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.4512 29.1152V29.2018H41.4775L41.4512 29.1152Z",
    fill: "#C1C2C3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.8516 29.1152V29.2018H44.8779L44.8516 29.1152Z",
    fill: "#B4B5B6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.9019 30.6152L42.8755 30.673H42.9282L42.9019 30.6152Z",
    fill: "#C1C2C3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.127 30.6445V30.7311H36.1533L36.127 30.6445Z",
    fill: "#B4B5B6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.821 30.6738V30.7027L41.8474 30.7604H41.8737L41.821 30.6738Z",
    fill: "#C1C2C3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.4023 30.6738V30.7027L43.4287 30.7604H43.4551L43.4023 30.6738Z",
    fill: "#C1C2C3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.1758 30.7305V30.8171H50.2021L50.1758 30.7305Z",
    fill: "#C1C2C3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.8737 30.7598V30.7886L41.9001 30.8464H41.9264L41.8737 30.7598Z",
    fill: "#B4B5B6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.8219 30.7598L42.3738 31.3371L41.9258 30.8175C41.9737 31.067 42.2057 31.5435 42.3738 31.7124L42.7252 31.0196L42.8219 30.7598Z",
    fill: "#A9ABAF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.4541 30.7598V30.7886L43.4805 30.8464H43.5068L43.4541 30.7598Z",
    fill: "#B4B5B6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.4029 30.7598L43.9549 31.3371L43.5068 30.8175C43.5548 31.067 43.7867 31.5435 43.9549 31.7124L44.3062 31.0196L44.4029 30.7598Z",
    fill: "#A9ABAF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.1758 30.8184V30.905H50.2021L50.1758 30.8184Z",
    fill: "#B4B5B6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.1016 30.8457V30.99H36.1279L36.1016 30.8457Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.1016 30.9922V31.4829H36.1279L36.1016 30.9922Z",
    fill: "#DEDDDE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.2021 31.1055V31.3653H50.2285L50.2021 31.1055Z",
    fill: "#FFF8DD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.1016 31.4824V31.6556H36.1279L36.1016 31.4824Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.1751 31.5684V31.6838H50.2014L50.1751 31.5684Z",
    fill: "#B4B5B6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.1758 31.6836V31.7702H50.2021L50.1758 31.6836Z",
    fill: "#C1C2C3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.127 31.7711V31.8577H36.1533L36.127 31.7711Z",
    fill: "#B4B5B6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.1758 31.8867V31.9733H50.2021L50.1758 31.8867Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.0842 32.6075H42.1105L42.1369 32.5497C42.0818 32.5153 42.0757 32.5449 42.0842 32.6075Z",
    fill: "#C1C2C3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.2463 32.6075H45.2726L45.299 32.5497C45.2439 32.5153 45.2378 32.5449 45.2463 32.6075Z",
    fill: "#C1C2C3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.082 32.5781C41.173 32.8307 41.4044 33.4187 41.6091 33.5596L42.0572 32.6359C41.9083 32.7328 41.6574 33.0591 41.6091 33.2421L41.082 32.5781Z",
    fill: "#A9ABAF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.2442 32.5781C44.3351 32.8307 44.5665 33.4187 44.7713 33.5596L45.2193 32.6359C45.0704 32.7328 44.8195 33.0591 44.7713 33.2421L44.2442 32.5781Z",
    fill: "#A9ABAF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.6652 33.0411H43.6916L43.7179 32.9833C43.6628 32.9488 43.6568 32.9785 43.6652 33.0411Z",
    fill: "#C1C2C3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.6641 33.0117C42.755 33.2643 42.9864 33.8522 43.1912 33.9932L43.6392 33.0695C43.4903 33.1664 43.2394 33.4927 43.1912 33.6757L42.6641 33.0117Z",
    fill: "#A9ABAF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.1103 34.4551L42.084 34.5128H42.1367L42.1103 34.4551ZM45.273 34.4551L45.2467 34.5128H45.2994L45.273 34.4551Z",
    fill: "#C1C2C3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.9912 34.4842V34.5131H33.861C33.7049 34.3888 33.196 34.4842 32.9912 34.4842Z",
    fill: "#99999B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.9648 34.5137V35.8994H32.9912V34.9178L32.9648 34.5137Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.9902 34.5137V35.8994H33.86V34.5137H32.9902Z",
    fill: "#373535"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.8613 34.5137V35.8994H33.8877V34.9178L33.8613 34.5137Z",
    fill: "#C1C2C3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.0293 34.5137V34.5425L41.0557 34.6003H41.082L41.0293 34.5137Z",
    fill: "#C1C2C3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.1934 34.5137V34.5425L44.2197 34.6003H44.2461L44.1934 34.5137Z",
    fill: "#C1C2C3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.0324 34.6563H42.0588L42.0851 34.5986C42.03 34.5641 42.024 34.5938 42.0324 34.6563Z",
    fill: "#B4B5B6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.1945 34.6569H45.2209L45.2472 34.5992C45.1921 34.5647 45.1861 34.5944 45.1945 34.6569Z",
    fill: "#B4B5B6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.082 34.5996V34.6285L41.1084 34.6862H41.1347L41.082 34.5996Z",
    fill: "#B4B5B6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.2451 34.5996V34.6285L44.2715 34.6862H44.2978L44.2451 34.5996Z",
    fill: "#B4B5B6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.0045 34.6289L41.6092 35.2063L41.1348 34.6578C41.1812 34.8988 41.4133 35.3956 41.5828 35.5527L41.921 34.8887L42.0045 34.6289Z",
    fill: "#A9ABAF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.1686 34.6289L44.7732 35.2063L44.2988 34.6578C44.3452 34.8988 44.5774 35.3956 44.7469 35.5527L45.085 34.8887L45.1686 34.6289Z",
    fill: "#A9ABAF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.5273 34.7148V34.7437H22.7134L22.3707 34.7148H21.5273Z",
    fill: "#7B7D7F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.055 35.4085V37.5447C21.7413 37.2012 21.3694 36.9416 20.948 36.7941C18.9266 36.0869 16.9058 38.4956 18.0401 40.5759C18.193 40.8564 18.3694 41.092 18.6023 41.2976C18.888 41.5497 19.2245 41.7158 19.5775 41.8124C19.9567 41.9163 20.3557 41.9139 20.7372 41.8268C21.2599 41.7076 21.6787 41.4211 22.055 41.0089V41.7018H23.0038C23.1411 41.7018 23.3266 41.7376 23.4518 41.6681C23.6521 41.5568 23.6643 41.2401 23.4782 41.1051C23.2867 40.9663 22.9333 41.0378 22.7138 41.0378V34.7445H21.7914C21.651 34.7445 21.4753 34.7131 21.3433 34.7734C21.1053 34.882 21.1012 35.224 21.317 35.3652C21.4968 35.4827 21.8507 35.4085 22.055 35.4085Z",
    fill: "#373535"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.7139 34.7441V41.0086H22.7402V36.4185V35.206L22.7139 34.7441Z",
    fill: "#B4B5B6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.6919 34.8887L43.6655 34.9464H43.7183L43.6919 34.8887Z",
    fill: "#C1C2C3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.6113 34.9453V34.9742L42.6377 35.0319H42.664L42.6113 34.9453Z",
    fill: "#C1C2C3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.6125 35.0899H43.6388L43.6652 35.0321C43.6101 34.9977 43.604 35.0274 43.6125 35.0899Z",
    fill: "#B4B5B6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.6636 35.0332V35.0621L42.6899 35.1198H42.7163L42.6636 35.0332Z",
    fill: "#B4B5B6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.5865 35.0605L43.1912 35.6379L42.7168 35.0894C42.7632 35.3305 42.9954 35.8272 43.1648 35.9843L43.503 35.3204L43.5865 35.0605Z",
    fill: "#A9ABAF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.959 35.1777V35.2066H14.2783L13.6458 35.1777H11.959Z",
    fill: "#595757"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.1441 35.8692C12.4655 37.3557 11.9896 39.0028 11.4222 40.5458C11.379 40.6633 11.3227 40.9569 11.2201 41.0222C11.0113 41.155 10.5895 40.9081 10.5612 41.3541C10.5495 41.5395 10.6917 41.6836 10.8511 41.7006C11.3757 41.7564 11.9314 41.7006 12.4588 41.7006C12.6506 41.7006 12.9042 41.7515 13.0079 41.5273C13.0835 41.3642 13.0166 41.1393 12.8542 41.0751C12.5852 40.9687 12.2145 41.0366 11.9317 41.0366L12.3227 39.9685L12.4852 39.6076L13.065 39.5932H14.5937L15.2262 39.6076L15.3931 39.9685L15.7797 41.0366C15.501 41.0366 15.1489 40.9742 14.8836 41.0751C14.7133 41.1398 14.6304 41.3845 14.7342 41.5562C14.8484 41.7452 15.0746 41.7006 15.2526 41.7006H16.6758C16.8594 41.7006 17.1231 41.7073 17.1502 41.4407C17.2085 40.8658 16.6588 41.2141 16.4737 41.0029C16.3411 40.8516 16.2859 40.5065 16.2058 40.3149C15.6968 39.0985 15.283 37.8256 14.8133 36.5909C14.6782 36.2358 14.5597 35.872 14.4136 35.5227C14.3809 35.4448 14.3589 35.2722 14.295 35.2196C14.1916 35.1347 13.8273 35.2052 13.6976 35.2052H12.3007C12.1198 35.2052 11.8533 35.1506 11.6945 35.2629C11.5249 35.3829 11.5293 35.6785 11.6945 35.8018C11.8804 35.9405 12.2445 35.8692 12.4588 35.8692H13.1441Z",
    fill: "#373535"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.5273 35.4082V35.4371H22.0281L21.5273 35.4082Z",
    fill: "#99999B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.0273 35.4375V37.516H22.0537V36.0149L22.0273 35.4375Z",
    fill: "#DEDDDE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.959 35.8691V35.898L13.1186 35.9269L12.8287 35.8691H11.959Z",
    fill: "#DEDDDE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.8306 35.8984L13.0838 37.9481L12.75 38.9007H14.9639L14.7047 38.179L14.182 36.7934L13.8306 35.8984Z",
    fill: "#161616"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.9902 35.8983V35.9272H33.86C33.7039 35.8028 33.195 35.8983 32.9902 35.8983Z",
    fill: "#B4B5B6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.1954 36.5617H46.169C46.1224 36.3679 45.8454 36.0559 45.677 36.3019C45.5784 36.4459 45.6156 36.6828 45.6156 36.8504H45.5892C45.5531 36.6632 45.3251 36.3 45.1148 36.4799C44.9793 36.596 44.9946 36.8852 45.0094 37.0525C45.0284 37.2661 45.3354 38.0561 45.6069 37.6876C45.7318 37.5178 45.6822 37.2742 45.6683 37.0814H45.6946C45.7102 37.2975 46.0143 37.7352 46.213 37.4566C46.3398 37.2788 46.2792 37.0498 46.2745 36.8504C46.3293 36.9453 46.3685 37.0503 46.4413 37.1343C46.5723 37.2851 46.7678 37.2999 46.8456 37.0814C46.9199 36.8714 46.8846 36.5952 46.8192 36.3885C46.752 36.1764 46.464 35.6995 46.2568 36.0421C46.1698 36.1861 46.1954 36.3979 46.1954 36.5617Z",
    fill: "#FFCD29"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.2129 36.9082H40.2392C40.2089 37.089 40.1723 37.35 40.2743 37.5144C40.4519 37.8 40.7505 37.4446 40.7927 37.2257H40.819C40.819 37.3962 40.7853 37.7155 40.9508 37.8175C41.2734 38.0163 41.484 37.3111 41.5043 37.0814C41.5185 36.9207 41.5114 36.6837 41.3944 36.5666C41.2004 36.3722 40.9603 36.7223 40.9245 36.9082H40.8981C40.8981 36.7337 40.925 36.5076 40.8103 36.3645C40.6256 36.1338 40.3549 36.4864 40.3183 36.6772C40.2711 36.5464 40.3199 36.3676 40.2832 36.2153C40.2073 35.9008 39.9277 36.0138 39.7999 36.2153C39.651 36.4505 39.6043 36.77 39.633 37.0525C39.685 37.5643 40.1499 37.2357 40.2129 36.9082Z",
    fill: "#FFCD29"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.1689 36.332V36.4186H46.1953L46.1689 36.332Z",
    fill: "#E7D189"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.1699 36.4473V36.5339H46.1963L46.1699 36.4473Z",
    fill: "#E0D1A2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.291 36.5918V36.6495L40.3437 36.5918H40.291Z",
    fill: "#F3D26B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.5879 36.5918V36.7361H45.6142L45.5879 36.5918Z",
    fill: "#F7D050"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.34766 36.6484V36.6773H7.53215L7.34766 36.6484Z",
    fill: "#7B7D7F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.1035 36.6484V36.6773H20.2353L20.1035 36.6484Z",
    fill: "#7B7D7F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.2363 36.6484V36.6773H20.3154L20.2363 36.6484Z",
    fill: "#8B8B8C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.06144 37.1683C7.6398 36.1849 5.35062 36.6734 4.90161 38.6406C4.83861 38.9167 4.81976 39.199 4.84451 39.4778C4.87092 39.7753 4.88709 40.0656 5.00704 40.3439C5.66315 41.8657 7.32562 42.1612 8.6661 41.6718C9.03361 41.5376 9.42009 41.3348 9.72033 41.0607C9.83458 40.9565 9.97506 40.8068 9.98389 40.6325C9.99839 40.3469 9.68133 40.2118 9.48313 40.3535C9.18594 40.566 8.94734 40.822 8.61339 40.9693C7.43178 41.4906 5.62673 41.193 5.47705 39.5067C5.31786 37.7132 7.20881 36.8551 8.50797 37.6062C8.70909 37.7224 8.89569 37.9036 9.00873 38.121C9.13254 38.3592 9.13231 38.8543 9.53584 38.6551C9.64954 38.5989 9.70871 38.454 9.72033 38.3231C9.74708 38.0217 9.72033 37.7023 9.72033 37.3993C9.72033 37.2565 9.73807 37.091 9.65884 36.9663C9.45938 36.6522 9.13257 36.8992 9.06144 37.1683Z",
    fill: "#373535"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.8984 36.6777V36.7932H40.9248L40.8984 36.6777Z",
    fill: "#E5D195"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.9066 36.6777C46.9066 36.9798 46.7663 37.5283 46.4322 37.1396C46.3873 37.0875 46.3555 37.0291 46.3267 36.9664H46.3004L46.274 37.3706C47.0281 37.3706 47.6508 37.4285 48.198 38.0923C49.1934 39.3002 48.2657 40.9278 46.9856 41.2005C45.5434 41.5076 44.0675 39.753 44.9739 38.2944C45.0899 38.1074 45.2361 37.9345 45.4043 37.8036L45.0353 37.2551C44.8645 37.3289 44.7333 37.512 44.6136 37.6593C44.1194 38.2683 43.941 39.1198 44.1215 39.911C44.3912 41.0923 45.5716 41.9697 46.6694 41.9029C47.5744 41.8478 48.4671 41.4382 48.9536 40.5461C49.8914 38.8263 48.6047 36.8246 46.9066 36.6777Z",
    fill: "#373535"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.4472 41.4414C39.3873 41.848 40.4661 42.1485 41.4518 41.6387C42.2235 41.2396 42.719 40.2404 42.058 39.4495C41.5287 38.8163 40.5407 38.7759 39.8177 38.6989C39.4656 38.6614 38.9227 38.6048 38.7416 38.2082C38.6581 38.0254 38.7514 37.8732 38.8689 37.7463C39.1127 37.4829 39.482 37.371 39.8177 37.371V37.3421C39.576 37.2655 39.6069 36.9262 39.6069 36.707C38.847 36.7289 37.7535 37.4317 38.1133 38.4103C38.5076 39.4825 39.843 39.305 40.6875 39.4976C41.0269 39.5751 41.5224 39.696 41.6803 40.0846C41.928 40.6957 41.0928 41.1291 40.6611 41.1816C40.0194 41.2597 38.9841 41.2999 38.5613 40.6331C38.4623 40.4765 38.5165 40.2972 38.4427 40.1424C38.3645 39.9777 38.1173 39.9029 37.9728 40.0076C37.695 40.2091 37.8147 40.9219 37.8147 41.2394C37.8147 41.3699 37.8318 41.518 37.9201 41.6147C38.0851 41.7954 38.428 41.7086 38.4472 41.4414Z",
    fill: "#373535"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.786 37.8324V36.822H51.6527C51.5007 36.822 51.2853 36.7927 51.152 36.8894C50.9575 37.0304 50.9741 37.3851 51.2047 37.4764C51.4738 37.5827 51.8443 37.5148 52.1271 37.5148V41.0657C51.7779 41.0657 51.3009 40.9733 50.9675 41.0849C50.7553 41.1559 50.672 41.4708 50.8621 41.6334C51.07 41.8114 51.6082 41.7008 51.8636 41.7008H53.893C54.1855 41.7008 54.5582 41.7688 54.8418 41.6911C55.2308 41.5846 55.0737 41.1174 54.7627 41.0464C54.1576 40.9083 53.4054 41.0368 52.786 41.0368V39.449C52.786 39.25 52.7323 38.944 52.7905 38.7562C52.8401 38.5954 53.1387 38.4154 53.2604 38.3135C53.6816 37.9611 54.1257 37.5303 54.6573 37.409C54.8758 37.3591 55.0647 37.4379 55.2371 37.5822C55.4203 37.7355 55.6527 38.0173 55.8873 37.765C56.0613 37.5779 55.9601 37.352 55.8169 37.1973C55.5486 36.9075 55.1907 36.7342 54.8154 36.7113C53.9897 36.6611 53.4299 37.4241 52.786 37.8324Z",
    fill: "#373535"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.5879 36.7363V36.8229H45.6142L45.5879 36.7363Z",
    fill: "#F3D26B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.8809 36.7363V36.8807H46.9072L46.8809 36.7363Z",
    fill: "#8F7730"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.3203 36.793V36.8218H26.0071L25.5327 36.793H24.3203ZM27.9574 36.793V36.8218H29.6442L29.1698 36.793H27.9574ZM32.0162 36.793V36.8218H33.8875L33.3867 36.793H32.0162Z",
    fill: "#FFF8DD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.8984 36.793V36.8507L40.9511 36.793H40.8984Z",
    fill: "#E0D1A2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.4141 36.793V36.8218H52.7846L52.3892 36.793H51.4141Z",
    fill: "#FFF8DD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.5361 37.5157C28.2299 38.4261 27.7774 39.3317 27.3808 40.2005C27.2909 40.3976 27.1989 40.6038 27.1217 40.8067C27.0994 40.8652 27.0754 41.0014 27.0075 41.0184C26.9323 41.0373 26.8951 40.8877 26.8713 40.8356C26.78 40.6356 26.6992 40.4297 26.6077 40.2294C26.2121 39.3627 25.6926 38.4402 25.4261 37.5157C25.6665 37.5157 26.0258 37.585 26.2431 37.4532C26.4354 37.3365 26.4154 37.0151 26.2431 36.8902C26.108 36.7923 25.8714 36.8229 25.716 36.8229H24.4773C24.2976 36.8229 24.071 36.8108 23.959 36.9961C23.9265 37.0499 23.9238 37.1071 23.9238 37.1693C23.9238 37.6885 24.4527 37.3851 24.6881 37.5302C24.789 37.5923 24.8447 37.8394 24.8946 37.9488C25.2823 38.7981 25.6578 39.6596 26.0279 40.518C26.1526 40.8072 26.2693 41.0967 26.3969 41.3841C26.4329 41.4652 26.4735 41.6333 26.5418 41.6872C26.5922 41.7269 26.7111 41.7016 26.7703 41.7016C26.964 41.7016 27.1855 41.735 27.3764 41.7016C27.4941 41.6811 27.5457 41.4587 27.5917 41.3552C27.7361 41.0298 27.8658 40.697 28.0134 40.3737C28.3309 39.6781 28.6095 38.9619 28.927 38.2663C29.0085 38.0878 29.1119 37.6301 29.2741 37.5302C29.4236 37.438 29.683 37.5448 29.8539 37.4773C30.0479 37.4005 30.0998 37.0972 29.9593 36.9384C29.8367 36.7997 29.595 36.8229 29.4322 36.8229H28.2198C28.0644 36.8229 27.8278 36.7923 27.6927 36.8902C27.4981 37.0313 27.5148 37.386 27.7454 37.4773C27.9796 37.5699 28.2905 37.5157 28.5361 37.5157Z",
    fill: "#373535"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.2297 37.5156V41.0376C32.6757 41.0376 32.0049 40.9237 31.4638 41.0472C31.162 41.116 31.03 41.5732 31.3847 41.6919C31.6823 41.7915 32.1272 41.7015 32.439 41.7015H34.811C35.0732 41.7015 35.729 41.8327 35.8916 41.5572C36.0568 41.277 35.8152 41.0631 35.5753 41.0376C35.0163 40.978 34.4241 41.0376 33.8622 41.0376V36.8228H32.3072C32.123 36.8228 31.8423 36.7836 31.701 36.9383C31.5555 37.0975 31.6082 37.3987 31.8064 37.4771C32.2057 37.6351 32.8074 37.5156 33.2297 37.5156Z",
    fill: "#373535"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.8604 36.8223V41.037H33.8867V37.9481V37.1398L33.8604 36.8223Z",
    fill: "#484646"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.6064 36.8223V36.9377H39.6328L39.6064 36.8223Z",
    fill: "#DEB533"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.9836 36.8223V36.9377H45.01L44.9836 36.8223Z",
    fill: "#F7D050"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.7842 36.8223V37.8038H52.8105C52.8105 37.5739 52.9007 36.9976 52.7842 36.8223Z",
    fill: "#B4B5B6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.5039 36.9102V37.0256H41.5303L41.5039 36.9102Z",
    fill: "#E5D195"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.3008 37.0254V37.1697H46.3271L46.3008 37.0254Z",
    fill: "#484646"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.1601 37.082L39.9492 37.313V37.3418H40.1864L40.1601 37.082Z",
    fill: "#373535"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.1855 37.082V37.1686H40.2119L40.1855 37.082Z",
    fill: "#8F7730"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.71973 37.2266V38.2947H9.74608C9.74608 38.0478 9.84481 37.415 9.71973 37.2266Z",
    fill: "#C1C2C3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.9307 37.2266V37.2554H45.0097L44.9307 37.2266Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.6172 37.2559V37.2847H46.6963L46.6172 37.2559Z",
    fill: "#786631"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.4794 37.2852L41.2949 37.6893C41.3853 37.8602 41.4689 38.2641 41.6112 38.3725C42.0421 38.7009 42.1383 38.055 42.1383 37.7471C42.1383 37.6698 42.1676 37.499 42.1251 37.4343C42.0608 37.3363 41.5985 37.3092 41.4794 37.2852Z",
    fill: "#373535"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.7207 37.2852L45.668 37.6027L45.8788 37.5161L45.7207 37.2852Z",
    fill: "#373535"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.29395 37.3418V37.3707H7.37301L7.29395 37.3418Z",
    fill: "#8B8B8C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.37402 37.3418V37.3707H7.47945L7.37402 37.3418Z",
    fill: "#99999B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.1025 37.3418V37.3707H20.1816L20.1025 37.3418Z",
    fill: "#8B8B8C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.2354 37.3418V37.3707H20.3144L20.2354 37.3418Z",
    fill: "#8B8B8C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.0283 37.3418V37.3707H40.1337L40.0283 37.3418Z",
    fill: "#99999B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.1338 37.3418V37.3707H40.2129L40.1338 37.3418Z",
    fill: "#8B8B8C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.5381 37.3418V37.3707H46.6172L46.5381 37.3418Z",
    fill: "#8B8B8C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.6172 37.3418V37.3707H46.6963L46.6172 37.3418Z",
    fill: "#99999B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.6963 37.3418V37.3707H46.7754L46.6963 37.3418Z",
    fill: "#8B8B8C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.9713 37.3809C19.4781 37.4859 19.0326 37.6953 18.715 38.1507C17.7235 39.5724 19.0356 41.495 20.5511 41.1723C21.276 41.0179 21.9527 40.3739 22.0271 39.5364C22.1356 38.3133 21.1344 37.1331 19.9713 37.3809Z",
    fill: "#161616"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.793 37.3711V37.4577H40.8193L40.793 37.3711Z",
    fill: "#A5882F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.4061 37.3817C46.2685 37.411 46.2126 37.5327 46.0898 37.5645C46.0163 37.5835 45.957 37.5094 45.879 37.526C45.6623 37.5722 45.3484 37.8376 45.1937 38.0071C45.0609 38.1526 44.9539 38.3446 44.873 38.5268C44.2112 40.0181 45.6792 41.457 47.0123 41.173C47.366 41.0977 47.677 40.9576 47.9611 40.7112C49.4054 39.4586 48.0979 37.0213 46.4061 37.3817Z",
    fill: "#161616"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.373 37.4297V37.4586H42.4521L42.373 37.4297Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.4531 37.4297V37.4586H42.5322L42.4531 37.4297ZM43.7973 37.4297V37.4586H43.8763L43.7973 37.4297Z",
    fill: "#DEDDDE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.877 37.4277V37.4566H43.956L43.877 37.4277Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.6641 37.457V37.4859H42.8222L42.6641 37.457Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.8223 37.457V37.4859H43.0068L42.8223 37.457ZM43.323 37.457V37.4859H43.5075L43.323 37.457Z",
    fill: "#DEDDDE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.5059 37.457V37.4859H43.664L43.5059 37.457Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.2949 37.5156V37.5445H24.6903L24.2949 37.5156Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.4531 37.5156V37.5445H26.0066L25.4531 37.5156Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.9316 37.5156V37.5445H28.5115L27.9316 37.5156Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.2754 37.5156V37.5445H29.6707L29.2754 37.5156ZM31.99 37.5156V37.5445H33.2024L32.8598 37.5156H31.99Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.3877 37.5156V37.5445H52.1257L51.3877 37.5156Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.2031 37.543V41.0072H33.2295V38.4668C33.2295 38.2485 33.3136 37.7095 33.2031 37.543Z",
    fill: "#A9ABAF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.7832 38.7285V41.0091H52.8096V39.3636L52.7832 38.7285Z",
    fill: "#B4B5B6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.7246 38.9004V38.9293H14.9649L14.3587 38.9004H12.7246Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.0332 39.1602V39.2468H44.0596L44.0332 39.1602Z",
    fill: "#8B8B8C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.6779 39.2188V39.3342H17.7043L17.6779 39.2188Z",
    fill: "#CFCCC5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.6934 39.2188V39.3631H44.7197L44.6934 39.2188ZM48.594 39.2188V39.3631H48.6204L48.594 39.2188Z",
    fill: "#706E6F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.2529 39.2188V39.3342H49.2793L49.2529 39.2188Z",
    fill: "#595757"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.0332 39.248V39.3347H44.0596L44.0332 39.248Z",
    fill: "#7B7D7F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.47656 39.2754V39.362H5.50292L5.47656 39.2754Z",
    fill: "#C1C2C3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.3633 39.3047V39.3913H18.3896L18.3633 39.3047Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.0342 39.334V39.4206H44.0605L44.0342 39.334Z",
    fill: "#8B8B8C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.2529 39.334V39.4206H49.2793L49.2529 39.334Z",
    fill: "#646262"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.81836 39.3926V39.4792H4.84472L4.81836 39.3926Z",
    fill: "#484646"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.46 39.5938V39.6226H15.2537L14.4894 39.5938H12.46Z",
    fill: "#595757"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.374 40.2578V40.3444H42.4004L42.374 40.2578Z",
    fill: "#C1C2C3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.7871 40.3438V41.3253H37.8135C37.8135 41.0954 37.9036 40.5191 37.7871 40.3438Z",
    fill: "#FFF8DD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.959 41.0078V41.0367H11.2225L10.959 41.0078Z",
    fill: "#DEDDDE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.959 41.0078V41.0367H12.6442L11.959 41.0078Z",
    fill: "#DEDDDE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.0684 41.0078V41.0367H15.7536L15.0684 41.0078Z",
    fill: "#DEDDDE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.4941 41.0078V41.0367H16.7841L16.4941 41.0078Z",
    fill: "#DEDDDE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.7402 41.0078V41.0367H23.2146L22.7402 41.0078Z",
    fill: "#DEDDDE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.5684 41.0078V41.0367H33.2024L32.7544 41.0078H31.5684Z",
    fill: "#DEDDDE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.8867 41.0078V41.0367H35.5471L35.0991 41.0078H33.8867Z",
    fill: "#DEDDDE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.8105 41.0078V41.0367H54.6818L54.181 41.0078H52.8105Z",
    fill: "#DEDDDE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.124 41.0371V41.066H52.1255L51.8356 41.0371H51.124Z",
    fill: "#8B8B8C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.0273 41.0664V41.7304H22.0537L22.0273 41.0664Z",
    fill: "#DEDDDE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.958 41.7012V41.73H12.6448L12.1704 41.7012H10.958Z",
    fill: "#595757"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.0693 41.7012V41.73H16.7825L16.3081 41.7012H15.0693Z",
    fill: "#595757"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.0537 41.7012V41.73H23.2134L22.8971 41.7012H22.0537Z",
    fill: "#595757"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.5605 41.701V41.7299H27.4303C27.2742 41.6055 26.7653 41.701 26.5605 41.701Z",
    fill: "#595757"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.5693 41.7012V41.73H35.5491L35.2591 41.7012H34.4948H31.5693Z",
    fill: "#595757"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.1514 41.7012V41.7301H54.683C54.5152 41.5963 53.9543 41.7012 53.7342 41.7012H51.1514Z",
    fill: "#595757"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.24219 41.875V41.9039H7.32125L7.24219 41.875ZM7.47939 41.875V41.9039H7.55846L7.47939 41.875Z",
    fill: "#484646"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.2353 41.875V41.9039H20.3143L20.2353 41.875Z",
    fill: "#484646"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.5117 41.875V41.9039H46.5908L46.5117 41.875ZM46.7226 41.875V41.9039H46.8016L46.7226 41.875Z",
    fill: "#484646"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 59,
    height: 59,
    rx: 7.5,
    stroke: "white",
    strokeOpacity: 0.2
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1322_39096"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 60,
    rx: 8,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_1322_39096"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 52,
    height: 25,
    fill: "white",
    transform: "translate(4 18)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRow64);
export default __webpack_public_path__ + "static/media/row-6-4.7e3554572d71b64451fcebddd3f8fcee.svg";
export { ForwardRef as ReactComponent };